import React from 'react';

const Hero = () => {
  return (
    <section className="bg-black text-white flex flex-col justify-center items-center px-6 py-20">
      <div className="text-center max-w-4xl mx-auto">
        {/* Logo */}
        <div className="mb-12">
          <img 
            src="/Union.png" 
            alt="Veipha" 
            className="h-48 sm:h-56 md:h-64 lg:h-72 w-auto mx-auto max-w-full"
          />
        </div>
        
      </div>
    </section>
  );
};

export default Hero;
